import { Controller } from "@hotwired/stimulus"

// Autocomplete client-side su un elenco di stringhe già presente in pagina
// (passato via suggestionsValue), senza round-trip al server: adatto a
// liste brevi/moderate note in anticipo (es. le keyword di un modello).
// Selezione possibile sia con il mouse (click) sia da tastiera
// (frecce su/giù per scorrere, invio per confermare, esc per chiudere).
export default class extends Controller {
  static targets = ["input", "results"]
  static values = { suggestions: Array }

  connect() {
    this.index = -1
    this.items = []

    this.boundKeydown = this.keydown.bind(this)
    this.boundOutsideClick = this.outsideClick.bind(this)

    this.inputTarget.addEventListener("keydown", this.boundKeydown)
    document.addEventListener("click", this.boundOutsideClick)
  }

  disconnect() {
    this.inputTarget.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("click", this.boundOutsideClick)
  }

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()

    this.clear()

    if (query.length === 0) return

    const filtered = this.suggestionsValue.filter(item =>
      item.toLowerCase().includes(query)
    )

    filtered.forEach(item => {
      const li = document.createElement("li")
      li.textContent = item
      li.classList.add("list-group-item", "list-group-item-action")
      li.dataset.value = item
      li.addEventListener("click", () => this.select(this.items.indexOf(li)))

      this.resultsTarget.appendChild(li)
      this.items.push(li)
    })
  }

  keydown(event) {
    if (!this.items.length) return

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.move(1)
        break

      case "ArrowUp":
        event.preventDefault()
        this.move(-1)
        break

      case "Enter":
        if (this.index >= 0) {
          event.preventDefault()
          this.select(this.index)
        }
        break

      case "Escape":
        this.clear()
        break
    }
  }

  move(step) {
    this.index += step

    if (this.index < 0) this.index = this.items.length - 1
    if (this.index >= this.items.length) this.index = 0

    this.items.forEach(el => el.classList.remove("active"))

    const active = this.items[this.index]
    active.classList.add("active")
    active.scrollIntoView({ block: "nearest" })
  }

  select(index) {
    const item = this.items[index]
    this.inputTarget.value = item.dataset.value
    this.clear()
  }

  outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.clear()
    }
  }

  clear() {
    this.resultsTarget.innerHTML = ""
    this.items = []
    this.index = -1
  }
}
